var _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursorMulti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A244F",
    points: "5.2,12.9 1.4,1.2 13.2,4.6 11,5.6 12.2,6 15.4,4.4 0,0 5,15.5 6.4,12.1 6,10.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A244F",
    d: "M12.2,6L11,5.6L3.6,3.5L6,10.8L6.4,12l2.2,7l3-7.5L19,7.9L12.2,6z M11.3,10.8L10.9,11l-0.1,0.2l-2.1,5.3 l-1.8-5.7L6.5,9.5L4.9,4.7l5,1.4l1.2,0.3L16.7,8L11.3,10.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorMulti);
export default __webpack_public_path__ + "static/media/cursor-multi.9a4206d2.svg";
export { ForwardRef as ReactComponent };